import * as React from 'react'
import APageRow from '../../components/atoms/APageRow'
import MForm from '../../components/molecules/MForm'
import { apiConsumer, IApiConsumer } from '../../data/ApiProvider'
import AField from '../../components/atoms/AField'
import AButton from '../../components/atoms/AButton'
import { FormattedMessage } from 'react-intl'
import AButtonGroup from '../../components/atoms/AButtonGroup'
import { IReport } from '../../data/admin/customer.interface'
import { IApiConsumerEntity } from '../../data/actions.interface'
import { getReport, modifyReport } from './reports.actions'
import APageHeader from '../../components/atoms/APageHeader'

interface IModifyReport extends IApiConsumer {
    customerId: string
    id: number
    onSuccess: (res: any) => void
    back: string,
    report: IApiConsumerEntity<IReport>
}

class ModifyReport extends React.Component<IModifyReport> {
    handleSubmit = (values: any) => {
        return this.props.dispatch(modifyReport(this.props.customerId, {id: this.props.id, name: values.name, url: values.report})).then(res => {
            return this.props.onSuccess(res)
        })
    }

    render() {
        const { report } = this.props
        if (report.status !== 'success') {
            return null
        }
        return (
            <div>
                 <APageHeader back={this.props.back}>Modify Report </APageHeader>
            
            <APageRow >
                <MForm
                    key="modify-report"
                    onSubmit={this.handleSubmit}
                >
                    <AField
                        
                        name="name"
                        type="text"
                        placeholder={report.response.name}
                       
                    />
                    <AField
                        name="report"
                        type="text"
                        placeholder={report.response.url}
                        
                    />
                    <AButtonGroup>
                   
                    <AButton outline color="error" type="submit">
                        Update Report
                    </AButton>
                    </AButtonGroup>
                </MForm>
            </APageRow>
            </div>
        )
    }
}

export default apiConsumer({
 report: props => getReport(props.customerId, props.id)
})(ModifyReport)
